import { KEYWORD_LIMIT } from './constants';
var METADATA_MODEL = {
  service: {
    name: [KEYWORD_LIMIT, true],
    version: true,
    agent: {
      version: [KEYWORD_LIMIT, true]
    },
    environment: true
  },
  labels: {
    '*': true
  }
};
var RESPONSE_MODEL = {
  '*': true,
  headers: {
    '*': true
  }
};
var DESTINATION_MODEL = {
  address: [KEYWORD_LIMIT],
  service: {
    '*': [KEYWORD_LIMIT, true]
  }
};
var CONTEXT_MODEL = {
  user: {
    id: true,
    email: true,
    username: true
  },
  tags: {
    '*': true
  },
  http: {
    response: RESPONSE_MODEL
  },
  destination: DESTINATION_MODEL,
  response: RESPONSE_MODEL
};
var SPAN_MODEL = {
  name: [KEYWORD_LIMIT, true],
  type: [KEYWORD_LIMIT, true],
  id: [KEYWORD_LIMIT, true],
  trace_id: [KEYWORD_LIMIT, true],
  parent_id: [KEYWORD_LIMIT, true],
  transaction_id: [KEYWORD_LIMIT, true],
  subtype: true,
  action: true,
  context: CONTEXT_MODEL
};
var TRANSACTION_MODEL = {
  name: true,
  parent_id: true,
  type: [KEYWORD_LIMIT, true],
  id: [KEYWORD_LIMIT, true],
  trace_id: [KEYWORD_LIMIT, true],
  span_count: {
    started: [KEYWORD_LIMIT, true]
  },
  context: CONTEXT_MODEL
};
var ERROR_MODEL = {
  id: [KEYWORD_LIMIT, true],
  trace_id: true,
  transaction_id: true,
  parent_id: true,
  culprit: true,
  exception: {
    type: true
  },
  transaction: {
    type: true
  },
  context: CONTEXT_MODEL
};
function truncate(value, limit, required, placeholder) {
  if (limit === void 0) {
    limit = KEYWORD_LIMIT;
  }
  if (required === void 0) {
    required = false;
  }
  if (placeholder === void 0) {
    placeholder = 'N/A';
  }
  if (required && isEmpty(value)) {
    value = placeholder;
  }
  if (typeof value === 'string') {
    return value.substring(0, limit);
  }
  return value;
}
function isEmpty(value) {
  return value == null || value === '' || typeof value === 'undefined';
}
function replaceValue(target, key, currModel) {
  var value = truncate(target[key], currModel[0], currModel[1]);
  if (isEmpty(value)) {
    delete target[key];
    return;
  }
  target[key] = value;
}
function truncateModel(model, target, childTarget) {
  if (model === void 0) {
    model = {};
  }
  if (childTarget === void 0) {
    childTarget = target;
  }
  var keys = Object.keys(model);
  var emptyArr = [];
  var _loop = function _loop() {
    var currKey = keys[i];
    var currModel = model[currKey] === true ? emptyArr : model[currKey];
    if (!Array.isArray(currModel)) {
      truncateModel(currModel, target, childTarget[currKey]);
    } else {
      if (currKey === '*') {
        Object.keys(childTarget).forEach(function (key) {
          return replaceValue(childTarget, key, currModel);
        });
      } else {
        replaceValue(childTarget, currKey, currModel);
      }
    }
  };
  for (var i = 0; i < keys.length; i++) {
    _loop();
  }
  return target;
}
export { truncate, truncateModel, SPAN_MODEL, TRANSACTION_MODEL, ERROR_MODEL, METADATA_MODEL, RESPONSE_MODEL };